module.exports = __webpack_public_path__ + "static/trips-banner-f7b41c5ba077db85ad8172bfc07daf6d.png";